'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScheduleModal = exports.ScheduleModalUnwrapped = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _Schedule = require('components/Schedule/Schedule');

var _PagePromotion = require('components/PagePromotion');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _multitrack = require('helpers/multitrack');

var _time = require('helpers/time');

var _explore = require('redux/modules/features/explore');

var _bound = require('redux/saga/entities/bound');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  var _state$features$explo = state.features.explore,
      venueScheduleDate = _state$features$explo.venueScheduleDate,
      venueId = _state$features$explo.venueId;


  var scheduleKey = venueId + '_' + venueScheduleDate;
  var venue = _bound.venueByIdV2.data(state, venueId);

  return {
    venue: venue,
    scheduleDate: venueScheduleDate,
    schedule: _bound.scheduleForVenue.data(state, scheduleKey),
    scheduleLoading: _bound.scheduleForVenue.loading(state, scheduleKey)
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  setVenueScheduleDate: _explore.setVenueScheduleDate
};

var ScheduleModalUnwrapped = exports.ScheduleModalUnwrapped = function (_Component) {
  (0, _inherits3.default)(ScheduleModalUnwrapped, _Component);

  function ScheduleModalUnwrapped(props) {
    (0, _classCallCheck3.default)(this, ScheduleModalUnwrapped);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScheduleModalUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(ScheduleModalUnwrapped)).call(this, props));

    _this.handleRequestScheduleForDate = props.setVenueScheduleDate.bind(_this);
    _this.handleOfferClick = _this.handleOfferClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ScheduleModalUnwrapped, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.setVenueScheduleDate((0, _time.iso8601Date)());
    }
  }, {
    key: 'handleOfferClick',
    value: function handleOfferClick() {
      (0, _multitrack.ga)('Explore Studios', 'Clicked Studio Schedule CTA', this.props.venue.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          venue = _props.venue,
          schedule = _props.schedule,
          scheduleLoading = _props.scheduleLoading,
          scheduleDate = _props.scheduleDate;


      return _react2.default.createElement(
        'div',
        { className: 'explore__modal explore__modal--schedule' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          tagName: 'h4',
          id: 'modal.schedule.title',
          defaultMessage: 'This week at {venue}',
          values: {
            venue: venue.name
          }
        }),
        _react2.default.createElement(_Schedule.ScheduleUnwrapped, {
          extraClass: 'schedule--no-scroll explore__modal__schedule',
          noLink: true,
          expanded: true,
          hideCtas: true,
          hideDateHeader: true,
          loading: scheduleLoading,
          schedule: schedule,
          timeZone: venue.tz,
          selectedDate: scheduleDate || (0, _time.iso8601Date)(),
          venueUrl: '/studios/' + venue.alias,
          numberOfDaysToShow: 7,
          onRequestScheduleForDate: this.handleRequestScheduleForDate
        }),
        _react2.default.createElement(_PagePromotion.PagePromotionCta, {
          extraClassForLink: 'bt--primary modal__closer _optimizely_search_test',
          extraClassForWrapper: 'explore__offer',
          onClick: this.handleOfferClick
        })
      );
    }
  }]);
  return ScheduleModalUnwrapped;
}(_react.Component);

ScheduleModalUnwrapped.propTypes = {
  venue: _propTypes2.default.object.isRequired,
  schedule: _propTypes2.default.array,
  scheduleDate: _propTypes2.default.string,
  scheduleLoading: _propTypes2.default.bool,
  setVenueScheduleDate: _propTypes2.default.func.isRequired
};

var ScheduleModal = exports.ScheduleModal = (0, _Modal2.default)({ headerClass: 'modal--640' })((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ScheduleModalUnwrapped));